export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_LAPIS-60X120.0652078a.jpg";